var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.6064C17.5228 22.6064 22 18.1292 22 12.6064C22 7.0836 17.5228 2.60645 12 2.60645C6.47715 2.60645 2 7.0836 2 12.6064C2 18.1292 6.47715 22.6064 12 22.6064Z",
    stroke: "#007755",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.1064L8 15.1064L7 18.6064L8 21.6064",
    stroke: "#007755",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.1064L16.5 18.6064L14 17.6064V14.1064L17 13.1064L21.5 13.6064",
    stroke: "#007755",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.10645L18.5 7.60645L15 8.10645V11.1064L17.5 10.1064H19.5L21.5 11.1064",
    stroke: "#007755",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.1064L5 9.10645L7.5 8.60645L9.5 5.60645L8.5 3.60645",
    stroke: "#007755",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.a3550f90d2d2ce81d59cad922cb34b90.svg";
export { ForwardRef as ReactComponent };